module.exports = __webpack_public_path__ + "static/swashbuckler-c65c215fd952c451674fff02a011c1f5.jpeg";